import React, { useEffect, useState } from "react";
import { Button, Pagination, Tab, Table, TableBody, TableCell, TableHead, TableRow, TextField,InputAdornment, Tooltip, Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import instance from "../../Utils/api";
import Grid from '@mui/material/Grid2';
import no_notification from "../../User/assets/no-notification.svg";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";


const Interaction = () => {
  const navigate = useNavigate();
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [consultations, setConsultations] = useState([]);
  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState('');

  const handleTabChange = (e, tabIndex) => {
    setCurrentTabIndex(tabIndex);
  };

  const getConsultations = async (page = 1, search) => {
    try {
      const response = await instance.get("/Consultation/getConsultations", {
        params: {
          search,
          page: page,
          limit: rowsPerPage,
        },
      });
      setConsultations(response?.data?.data);
      setTotalPages(response?.data?.totalPages);
      setCurrentPage(response?.data?.currentPage);
      setTotalCount(response?.data?.total);
    } catch (err) {
      console.log(err);
    }
  };

  // Pagination change handler
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  useEffect(() => {
    getConsultations(currentPage, search);
  }, [currentPage, search]);


  const getPayments = async () => {
    try {
      const response = await instance.get("/Payment/getPayments");
      // const paymentFilter = response?.data?.data.filter(
      //   (item) => item?.status === "Pending" && item?.for === "Consultation"
      // );
      setPayments(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

    getPayments();
  }, []);
  const getStatusBackgroundColor = (status) => {
    const colors = {
      "New Order received": "#E0F7FA",           // light cyan
      "Designer Assigned": "#E8F5E9",            // light green
      "Booked": "#E3F2FD",                   // light blue
      "Estimate Sent": "#FFF3E0",                // light orange
      "Estimate approved by Customer": "#EDE7F6",// light indigo
      "Order In Progress": "#E0F2F1",            // light teal
      "Order Ready": "#FCE4EC",                  // light pink
      "Delivery Scheduled": "#CFD8DC",           // blue-grey
      "Completed": "#F1F8E9",              // light lime
      "Alteration request raised": "#FFF8E1",    // light yellow
      "Order Canceled": "#FFEBEE",               // light red
    };
    return colors[status] || "#ECEFF1"; // Default light grey
  };


  // Function for status text color
  const getStatusTextColor = (status) => {
    const colors = {
      "New Order received": "#00796B",           // teal
      "Designer Assigned": "#2E7D32",            // green
      "Booked": "#1565C0",                   // blue
      "Estimate Sent": "#EF6C00",                // deep orange
      "Estimate approved by Customer": "#5E35B1",// indigo
      "Order In Progress": "#00897B",            // teal
      "Order Ready": "#C2185B",                  // pink
      "Delivery Scheduled": "#263238",           // blue-grey (dark)
      "Completed": "#689F38",              // lime green
      "Alteration request raised": "#F9A825",    // yellow
      "Order Canceled": "#D32F2F",               // red
    };
    return colors[status] || "#37474F"; // Default dark grey
  };

  // console.log(payments);
  // console.log(consultations);


  return (
    <React.Fragment>
      <section className='mycart' style={{ marginTop: "80px" }}>
        <div className='mycart-title'>
          {/* <Button onClick={() => navigate(-1)}>
            <KeyboardBackspaceIcon />
            Back
          </Button> */}
          <Typography variant="h4">My Consultations</Typography>
          <TextField
            placeholder={"Search Consultations"}
            type="search"
            variant="outlined"
            // style={{ marginBottom: 20 }}
            value={search}
            onChange={(e) => { setSearch(e.target.value) }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            size='small'
          />
        </div>
        {/* <div className="interaction-tabs"> */}
        <div className="employee-table">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">S.No</TableCell>
                <TableCell align="center">Consultations ID</TableCell>
                <TableCell align="center">Order ID</TableCell>
                <TableCell align="center">Date</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Status</TableCell>
                {/* <TableCell>Amount</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {consultations.length > 0 ? (
                consultations.map((order, index) => (
                  <TableRow
                    key={order._id}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      // const filteredPayment = payments?.find((data) => data?.consultation_id === order?._id);
                      // if (filteredPayment) {
                      navigate(`/profile/forconsultation-details/${order?._id}`);
                      // }
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{order?.consultation_id}</TableCell>
                    <TableCell>{order?.Order?.order_id}</TableCell>
                    <TableCell>{new Date(order?.createdAt).toLocaleDateString("en-GB")}</TableCell>
                    <TableCell>{order?.consultation_type}</TableCell>
                    <TableCell>
                      <span
                        style={{
                          backgroundColor: getStatusBackgroundColor(order.status),
                          color: getStatusTextColor(order.status),
                          padding: "5px 10px",
                          borderRadius: "5px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {order?.status}
                      </span>
                    </TableCell>
                    {/* <TableCell>₹{order.total_amount}</TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={12} align="center">
                    <Typography>No Consultations available</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {currentPage &&
            <div className="pagination_table">
              <div>
                Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                {Math.min(currentPage * rowsPerPage, totalCount)} of {totalCount} results
              </div>

              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handleChange}
                color="primary"
              />
            </div>
          }
          {/* </div> */}

          {currentTabIndex === 1 &&
            <section className="mycart">
              {payments.length === 0 ? (
                <React.Fragment>
                  <div className="cart-no-items">
                    <img src={no_notification} alt="no_notification" />
                    <Typography>No Payments Yet!!</Typography>
                  </div>
                </React.Fragment>
              ) : (
                <>
                  <div className="payments-approve-container">
                    {payments.map((payment, index) =>
                      payment?.status === "Pending" ? (
                        <Tooltip title='View Consultation Details' placement="left-start" >
                          <div
                            key={index}
                            className="my-notifications"
                            onClick={() =>
                              navigate(
                                `/profile/forconsultation-details/${payment?._id}`
                              )
                            }
                          >
                            <div className="notifications-details">
                              <Typography variant="h5">
                                For {payment?.for}
                              </Typography>
                              <Typography>
                                {payment?.payment?.description}
                              </Typography>
                              <Typography variant="h6">
                                Amount: <strong>₹{payment.amount}</strong>
                              </Typography>
                            </div>
                            <div className="notifications-date">
                              <Typography variant="h6">
                                Payment Date:{" "}
                                <strong>
                                  {payment?.createdAt
                                    ? new Date(payment?.createdAt).toLocaleString()
                                    : "---"}
                                </strong>
                              </Typography>
                              <div className="approve">
                                {/* <Button className="approve-cancel-btn">Cancel</Button> */}
                                <Button
                                  className="approve-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (payment?.payment_link) {
                                      window.open(payment?.payment_link, "_balnk");
                                    } else {
                                      toast.error("Payment Unavailable");
                                    }
                                  }}
                                  disabled={!payment?.payment_link}
                                >
                                  {payment?.payment_link
                                    ? "Pay/Approve"
                                    : "Unavailable"}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Tooltip>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                </>
              )}
            </section>}

        </div>
      </section>
    </React.Fragment>
  );
};

export default Interaction;
